import React from 'react';
import {
  FieldProps,
  ErrorMessage,
} from 'formik';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type RadioProps = {
  id: number;
  align?: string;
  justify?: string;
  label?: string;
  placeholder?: string;
} & FieldProps;

const RadioField = ({
  id,
  align,
  justify,
  label,
  field,
  form: { touched, errors },
  placeholder,
  ...props
}: RadioProps) => {
  const iserror = (touched[field.name] && errors[field.name]);

  return (
    <Flex
      column
      shrink="0"
      width="100%"
      spacing={5}
    >
      <Flex width="100%" spacing={5} align={align}>
        <S.Radio
          {...field}
          {...props}
          id={id}
          type="radio"
          iserror={iserror}
          placeholder={placeholder}
        />
        {label && (
          <S.Label
            htmlFor={`${id || field.name}-id`}
            color={iserror ? 'danger' : ''}
          >
            {label}
          </S.Label>
        )}
      </Flex>
      <Flex flex="0 1 100%;">
        <ErrorMessage
          name={field.name}
          component={S.Error}
        />
      </Flex>
    </Flex>
  );
};

RadioField.defaultProps = {
  align: 'center',
  justify: 'flex-start',
  label: '',
  placeholder: '',
};

export default RadioField;
